import React from 'react';
import CommonButton from '../CommonButton';

function PartnerProfileCard({ profile, onAccept, onReject }) {
    if (!profile) return null;

    return (
        <div className="partner-profile-card">
            <h2>{profile.nickname}</h2>
            <p>특징: {profile.character}</p>
            <div className="matching-actions">
                <CommonButton 
                    text="수락" 
                    variant="success" /* 초록색 */
                    onClick={onAccept} 
                />
                <CommonButton 
                    text="거절" 
                    variant="danger"  /* 빨간색 */
                    onClick={onReject} 
                />
            </div>
        </div>
    );
}

export default PartnerProfileCard;